import { isTranHuyLieu } from 'helpers/common';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from 'components/AuthStore';

var checkPermission = false;

export default function MenuTreeView() {
  const user = useSelector(selectUser);
  var arrLink = [
    '/',
    '/home',
    '/trang-chu',
    '/huong-dan',
    '/account',
    '/khoi',
    '/khoi-tao-phong-thi',
    '/step-them-hoc-sinh',
    '/step-them-hoc-sinh-phong',
    '/step-upload-de-thi',
    '/step-upload-de-thi-thptqg',
    '/step-chuyen-de',
    '/lop',
    '/xu-ly-tinh-huong-thi',
    '/quan-ly-diem',
    '/diem-danh-sach',
    '/chi-tiet-diem',
    '/de-thi-can-lam',
    '/de-thi',
    '/danh-sach-cau-hoi',
    '/cap-nhat-cau-hoi',
    '/cap-nhat-cau-hoi-thptqg',
    '/chi-tiet-lop',
    '/quan-ly-ky-thi',
    '/quan-ly-mon-hoc',
    '/chi-tiet-bai-thi',
    '/chi-tiet-bai-thi-thptqg',
    '/hanh-trinh-lam-bai',
    '/thi-thu',
    '/thi-thu-thpt-qg',
    '/cham-diem-bai-thi',
    '/danh-sach-bai-thi-tu-luan',
    '/danh-sach-bai-thi-tu-luan-lop',
    '/danh-sach-chua-cham-diem',
    '/danh-sach-chua-cham-diem-lop',
    '/danh-sach-da-cham-diem',
    '/danh-sach-da-cham-diem-lop',
    '/danh-sach-de-thi-tu-luan',
    '/testing',
    '/danh-sach-giao-vien',
    '/in-bai-thi',
    '/de-thi-da-chuyen',
    '/danh-sach-giao-vien-quan-ly-lop',
    //hs
    '/phong-thi-truc-tuyen',
    '/lich-su-thi',
    '/thi',
    '/thi-thpt-2025',
    '/xem-ket-qua',
    '/xem-ket-qua-2025',
    '/thong-tin-tai-khoan',
    '/tao-de-thi-tu-ngan-hang',
    '/tai-lieu-huong-dan'
  ];

  arrLink.forEach((value) => {
    if (value == window.location.pathname) {
      checkPermission = true;
      //className = "Mui-selected makeStyles-selected-20"
    }
  });
  if (!checkPermission) {
    window.location.href = '/not-found';
  }
  return (
    <div className="sidebar" id="menustudent">
      <div className="navbar-brand-box">
        <a href="javascript:void(0)" className="logo" title="">
          <img
            src={
              process.env.REACT_APP_STATIC_URL +
              'content/assets/images/logo_hst_chu_den.png'
            }
            alt="logo"
            style={{ height: '72px' }}
            className="logo-full"
          />
          <img
            src={
              process.env.REACT_APP_STATIC_URL +
              'content/assets/images/icon-user.png'
            }
            alt=""
            style={{ height: '35px' }}
            className="logo-mini"
          />
        </a>

        <a href="#" className="nav-link menu-toggle" onclick="hideMenu()">
          <span className="icon-menu" />
        </a>
      </div>
      <div className="sidebar-menu-scroll">
        <ul className="sidebar-menu">
          <li
            className="sidebar-item sidebar-link active"
            id="phongthitructuyen">
            <Link to="/phong-thi-truc-tuyen">
              <span className="icon-home" />
              <span>Phòng thi trực tuyến</span>
            </Link>
          </li>

          <li className="sidebar-item sidebar-link" id="dethicanlam">
            <Link to="/de-thi-can-lam">
              <span className="icon-open-book" />
              <span>Bài thi cần làm</span>{' '}
            </Link>
          </li>

          <li className="sidebar-item sidebar-link" id="lichsuthi">
            <Link to="/lich-su-thi">
              <span className="icon-presentation" />
              <span>Lịch sử thi</span>
            </Link>
          </li>

          {isTranHuyLieu(user) && (
            <li className="sidebar-item sidebar-link" id="systemlms360">
              <a
                href="https://lms360.vn/"
                target="_blank"
                rel="noopener noreferrer">
                <span className="icon-presentation" />
                <span>Hệ thống QLHT LMS360</span>
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
